var map = {
	"./404-bg.svg": "3bfe",
	"./SPlogo.svg": "d30c",
	"./action-black.svg": "a66c",
	"./action-blue.svg": "c5dd",
	"./action-dark.svg": "7d96",
	"./action-dark2.svg": "ed18",
	"./action-gray.svg": "efd7",
	"./action-white.svg": "12f2",
	"./action.svg": "0ca3",
	"./activity.svg": "3f5a",
	"./add.svg": "3aba",
	"./calendar.svg": "d2f5",
	"./check.svg": "5621",
	"./chevron-down-blue.svg": "be49",
	"./chevron-down-dark.svg": "fcb6",
	"./chevron-down-white.svg": "60c3",
	"./chevron-down.svg": "d234",
	"./chevron-left-blue.svg": "26e3",
	"./chevron-left-small.svg": "d230",
	"./chevron-left.svg": "fe52",
	"./chevron-right.svg": "0e59",
	"./chevron-up.svg": "0d19",
	"./chick-fil-a-logo.png": "5bd2",
	"./close-dark.svg": "4c58",
	"./close-gray.svg": "b589",
	"./close.svg": "cf5a",
	"./colgate-logo.png": "5653",
	"./dashboard-placeholder.png": "3ab6",
	"./dashboard.png": "4aa5",
	"./default_startup_logo.svg": "07a3",
	"./drag-n-drop2-blue.svg": "1b16",
	"./drag-n-drop2.svg": "1693",
	"./drag-n-drop21.svg": "1533",
	"./edit-white.svg": "4f4f",
	"./edit.svg": "5e3a",
	"./globe-solid.svg": "673c",
	"./greeting.png": "3de0",
	"./greeting.webp": "04c8",
	"./home.svg": "f79a",
	"./icon-activity-call-active.svg": "4b84",
	"./icon-activity-call.svg": "034b",
	"./icon-activity-demo-active.svg": "7244",
	"./icon-activity-demo.svg": "222d",
	"./icon-activity-email-active.svg": "3c18",
	"./icon-activity-email.svg": "a6c2",
	"./icon-activity-meeting-active.svg": "cdfa",
	"./icon-activity-meeting.svg": "4916",
	"./icon-activity-news-active.svg": "5729",
	"./icon-activity-news.svg": "f1d9",
	"./icon-activity-note-active.svg": "d7c6",
	"./icon-activity-note.svg": "22c3",
	"./icon-activity.svg": "a620",
	"./icon-add-dark.svg": "ec28",
	"./icon-add.svg": "818f",
	"./icon-admin-blue.svg": "bc92",
	"./icon-admin-yellow.svg": "70d4",
	"./icon-admin.svg": "f326",
	"./icon-ai-generated-plate.png": "7c9e",
	"./icon-ai-generated.svg": "5e34",
	"./icon-ai-similar-blue.svg": "938b",
	"./icon-ai-similar.svg": "b1f4",
	"./icon-ai.svg": "5a5c",
	"./icon-archive.svg": "d2e6",
	"./icon-arrow-triangle-shadow.svg": "bb84",
	"./icon-arrow-triangle-shadow2-yellow.svg": "9f47",
	"./icon-arrow-triangle-shadow2.svg": "ae02",
	"./icon-arrow-triangle.svg": "63eb",
	"./icon-article.svg": "4422",
	"./icon-attach.png": "9246",
	"./icon-badge.png": "129a",
	"./icon-binoculars-active.svg": "4a8d",
	"./icon-binoculars-black.svg": "7a42",
	"./icon-binoculars-light.svg": "58b2",
	"./icon-binoculars.svg": "964d",
	"./icon-blank-white.svg": "d793",
	"./icon-blank.svg": "7f5f",
	"./icon-building-blue-old.svg": "553f",
	"./icon-building-blue.svg": "8e86",
	"./icon-building-dark-old.svg": "61d1",
	"./icon-building-dark.svg": "c3aa",
	"./icon-building-green-old.svg": "c8e4",
	"./icon-building-green.svg": "b489",
	"./icon-building-old.svg": "bdcf",
	"./icon-building.svg": "23c3",
	"./icon-calendar.svg": "8cc4",
	"./icon-call.svg": "feeb",
	"./icon-categories.svg": "a60a",
	"./icon-chat-blue.svg": "6fbb",
	"./icon-chat.svg": "46e8",
	"./icon-check.svg": "2e14",
	"./icon-checkmark-blue.svg": "0af6",
	"./icon-checkmark-gray.svg": "d580",
	"./icon-checkmark-gray2.svg": "e7b9",
	"./icon-clock-blue.svg": "f402",
	"./icon-clock-white.svg": "b649",
	"./icon-clock.svg": "992e",
	"./icon-close-blue.svg": "5977",
	"./icon-close-dark.svg": "b095",
	"./icon-close-light.svg": "1c80",
	"./icon-close-red.svg": "c54a",
	"./icon-close-white.svg": "431a",
	"./icon-close.svg": "ce86",
	"./icon-copy-white.svg": "b15a",
	"./icon-copy.svg": "4e6a",
	"./icon-custom-remove.svg": "426c",
	"./icon-data-gray.svg": "a27f",
	"./icon-data.svg": "f8d6",
	"./icon-delete.svg": "b069",
	"./icon-demo.svg": "8cc5",
	"./icon-download.png": "737b",
	"./icon-drag-n-drop-blue.svg": "e295",
	"./icon-drag-n-drop.svg": "6d68",
	"./icon-ecosystem-black.svg": "573f",
	"./icon-ecosystem-blue.svg": "eb20",
	"./icon-ecosystem-gray.svg": "c215",
	"./icon-ecosystem-graylight.svg": "0fdc",
	"./icon-ecosystem-green.svg": "5e02",
	"./icon-ecosystem-white.svg": "9888",
	"./icon-ecosystem.svg": "e369",
	"./icon-edit-blue.svg": "9afe",
	"./icon-edit-dark.svg": "15aa",
	"./icon-edit.svg": "d033",
	"./icon-email.svg": "e092",
	"./icon-employees-light.png": "54cc",
	"./icon-enter.png": "1b40",
	"./icon-envelope.svg": "22ff",
	"./icon-envelope2.svg": "4ae5",
	"./icon-eye-hide.svg": "0d0c",
	"./icon-eye-show.svg": "7aa2",
	"./icon-eye.svg": "dc1b",
	"./icon-facebook.svg": "6651",
	"./icon-favorite.svg": "64ee",
	"./icon-file-csv-blue.svg": "026d",
	"./icon-file-csv.svg": "b9ef",
	"./icon-file.svg": "2a00",
	"./icon-folder-gray.svg": "9798",
	"./icon-folder-white.svg": "506d",
	"./icon-folder.svg": "5a38",
	"./icon-founded-light.png": "cbcb",
	"./icon-founded.svg": "680d",
	"./icon-funding-blue.svg": "8bda",
	"./icon-funding-green.svg": "0640",
	"./icon-funding-light.png": "b52c",
	"./icon-funding-old.svg": "a326",
	"./icon-funding.svg": "3669",
	"./icon-general-edit.svg": "8c25",
	"./icon-globe-pdf.svg": "31ee",
	"./icon-globe-real.png": "5fc2",
	"./icon-globe-real.webp": "3b69",
	"./icon-globe-white.svg": "8f1b",
	"./icon-globe.svg": "988a",
	"./icon-help-button.svg": "401d",
	"./icon-home-white.svg": "5df7",
	"./icon-home.svg": "49f5",
	"./icon-income-blue.svg": "8ebb",
	"./icon-income-light.png": "577f",
	"./icon-income.svg": "a3b4",
	"./icon-info-gray.svg": "a21c",
	"./icon-info-light.svg": "247b",
	"./icon-info.svg": "68b7",
	"./icon-information.svg": "590e",
	"./icon-invite.svg": "16e3",
	"./icon-knowledge.webp": "e286",
	"./icon-leave.svg": "8077",
	"./icon-light-clock.svg": "4d5a",
	"./icon-light-tag.svg": "28c0",
	"./icon-light-text.svg": "1a33",
	"./icon-light-tracker.svg": "0b78",
	"./icon-light-user.svg": "e731",
	"./icon-lightbulb-blue.svg": "1bb8",
	"./icon-lightbulb-gray.svg": "fc03",
	"./icon-lightbulb.svg": "6c94",
	"./icon-link.svg": "1c46",
	"./icon-linkedin.svg": "4d5b",
	"./icon-list-mouse.svg": "cd76",
	"./icon-list-view.svg": "49cc",
	"./icon-list.svg": "dad4",
	"./icon-ln.svg": "e1a4",
	"./icon-location-blue.svg": "627b",
	"./icon-location-light.png": "f491",
	"./icon-logs.svg": "0924",
	"./icon-meeting.svg": "4c1b",
	"./icon-merge.svg": "91cd",
	"./icon-minus-blue.svg": "2b77",
	"./icon-minus.svg": "c5de",
	"./icon-mouse.svg": "33df",
	"./icon-news-gray.svg": "79df",
	"./icon-news.png": "b87f",
	"./icon-news.svg": "23be",
	"./icon-no-content.svg": "0a6a",
	"./icon-note-from.svg": "d218",
	"./icon-note.svg": "f5e3",
	"./icon-notification-light.svg": "3769",
	"./icon-notification-off.svg": "951c",
	"./icon-notification.svg": "184c",
	"./icon-notifications-off.png": "e69f",
	"./icon-notifications.png": "3acd",
	"./icon-notifications.svg": "800f",
	"./icon-offset.svg": "8aa8",
	"./icon-open-popup-normal.svg": "8aa1",
	"./icon-open-popup-round.svg": "1401",
	"./icon-open-popup-transparent.svg": "9f74",
	"./icon-open-popup-white.svg": "854d",
	"./icon-open-popup.svg": "9e5d",
	"./icon-pdf.svg": "703b",
	"./icon-pic.svg": "aff4",
	"./icon-pin.svg": "239c",
	"./icon-play-video.svg": "3c6d",
	"./icon-play.svg": "fc1c",
	"./icon-poc.svg": "734d",
	"./icon-portfolio.svg": "40ac",
	"./icon-ppt.svg": "ea62",
	"./icon-premium.svg": "6c5a",
	"./icon-privacy.svg": "a7ad",
	"./icon-profile-blue.svg": "7369",
	"./icon-profile-gray.svg": "940b",
	"./icon-profile.svg": "e19d",
	"./icon-pushpin-blue.svg": "5c5e",
	"./icon-pushpin.svg": "3c00",
	"./icon-question-blue.svg": "449d",
	"./icon-question-mark-blue.svg": "ee5e",
	"./icon-question.svg": "1d36",
	"./icon-quote.svg": "1157",
	"./icon-r-note.svg": "a0c4",
	"./icon-r-play.svg": "cc68",
	"./icon-r-walkthrough.svg": "91126",
	"./icon-radar.svg": "d373",
	"./icon-rated.svg": "229c",
	"./icon-relations.svg": "58b1",
	"./icon-remove-red.svg": "295b",
	"./icon-remove.svg": "a3ae",
	"./icon-report.svg": "967c",
	"./icon-reporting.svg": "476c",
	"./icon-resize.svg": "1a75",
	"./icon-save-light.svg": "f6f6",
	"./icon-save.svg": "a139",
	"./icon-schedule-gray.svg": "361a",
	"./icon-schedule.svg": "90f6",
	"./icon-search-black.svg": "011f",
	"./icon-search-blue.svg": "b8de",
	"./icon-search-white.svg": "83fd",
	"./icon-send.svg": "f4cb",
	"./icon-settings-dark.svg": "3509",
	"./icon-settings.svg": "c57e",
	"./icon-share-portfolio.png": "3ca6",
	"./icon-share-portfolio.svg": "a83e",
	"./icon-share.svg": "498d",
	"./icon-show.svg": "c4dd",
	"./icon-similar-blue.svg": "a604",
	"./icon-similar-gray.svg": "62a5",
	"./icon-similar.svg": "2ab2",
	"./icon-sort.svg": "6cf1",
	"./icon-speed-0.svg": "fbe7",
	"./icon-speed-1.svg": "1e3f",
	"./icon-speed-10.svg": "2b4c",
	"./icon-speed-2.svg": "4259",
	"./icon-speed-3.svg": "94b3",
	"./icon-speed-4.svg": "6459",
	"./icon-speed-5.svg": "c964",
	"./icon-speed-6.svg": "0309",
	"./icon-speed-7.svg": "c260",
	"./icon-speed-8.svg": "a183",
	"./icon-speed-9.svg": "16be",
	"./icon-speed-gray.svg": "ee4b",
	"./icon-speed.svg": "9f26e",
	"./icon-start-ups-blue.svg": "2bfa",
	"./icon-startup-white-old.svg": "c12f",
	"./icon-startup-white.svg": "e5f8",
	"./icon-startups-light.png": "0573",
	"./icon-startups-white.svg": "9712",
	"./icon-sync.svg": "1942",
	"./icon-tag.svg": "3239",
	"./icon-tasks-blue.svg": "c7e2",
	"./icon-tasks-white-old.svg": "3bfb",
	"./icon-tasks-white.svg": "a792",
	"./icon-tasks.svg": "9b46",
	"./icon-team-white.svg": "3ac3",
	"./icon-team.svg": "40c1",
	"./icon-template-blue.svg": "084c",
	"./icon-template.svg": "0175",
	"./icon-text-document.webp": "1db8",
	"./icon-thumbs-down-fill.svg": "4617",
	"./icon-thumbs-down-full.svg": "4668",
	"./icon-thumbs-up-fill.svg": "6103",
	"./icon-thumbs-up-full.svg": "406d",
	"./icon-thumbs-up.svg": "d3ec",
	"./icon-tool.svg": "536a",
	"./icon-tooltip.svg": "c5f4",
	"./icon-track-blue.svg": "bc49",
	"./icon-track-dark.svg": "20ba",
	"./icon-track-gray.svg": "183c",
	"./icon-track-graylight.svg": "4d51",
	"./icon-track-white.svg": "c4bb",
	"./icon-trackers-blank.svg": "c776",
	"./icon-trash-can.svg": "54f0",
	"./icon-triangle.svg": "ea43",
	"./icon-twitter.svg": "5304",
	"./icon-user-plus.svg": "c1a4",
	"./icon-user.svg": "e80b",
	"./icon-users-gray.svg": "40de",
	"./icon-users.svg": "d16af",
	"./icon-valuation.svg": "8403",
	"./icon-walkthrough.svg": "7680",
	"./icon-watched.svg": "13bc",
	"./icon-x.svg": "4340",
	"./icon-y.svg": "3f67",
	"./icon-youtube.svg": "a1cf",
	"./icons-error-gray.svg": "f3f8",
	"./icons-filter-blue.svg": "e29b",
	"./icons-filter.svg": "36b3",
	"./icons-information.svg": "38c6",
	"./icons-profile.svg": "6d67",
	"./linkedin.svg": "a79e",
	"./logo-bloomberg.png": "859c",
	"./logo-entrepreneur.png": "1fd0",
	"./logo-inc.png": "ef083",
	"./logo-on-white.png": "012f",
	"./logo-pdf-link.svg": "4bc8",
	"./logo-upstart.png": "5a49",
	"./logo-usnews.png": "3dc0",
	"./logo.png": "013a",
	"./logo.svg": "4d87",
	"./manager.png": "673b",
	"./minimize.svg": "1dee",
	"./modal-previews/activity-feed-preview.png": "8bdf",
	"./modal-previews/add-startup-preview.png": "5211",
	"./modal-previews/analyst-hours.png": "d8b9",
	"./modal-previews/fields-history-preview.png": "caec",
	"./notify-icon-error.svg": "5593",
	"./notify-icon-warn.svg": "aee4",
	"./popup-arrow.png": "82ba",
	"./rectangle.svg": "f76d",
	"./save.svg": "2463",
	"./search-button.svg": "1e75",
	"./search-dark.svg": "95f3",
	"./search.svg": "8ebbf",
	"./sp-logo.svg": "0925",
	"./star-yellow.svg": "788f",
	"./star.svg": "1098",
	"./start-ups-black.svg": "abcd",
	"./start-ups-gray.svg": "35b1",
	"./start-ups-green.svg": "4cfb",
	"./start-ups.svg": "0b1b",
	"./time-badge-bronze.svg": "3d1f",
	"./time-badge-gold.svg": "0238",
	"./time-badge-platinum.svg": "f5d7",
	"./time-badge-silver.svg": "4adc",
	"./time-badge-start.svg": "76968",
	"./track-black.svg": "4d70",
	"./v-1.png": "488e",
	"./v-2.png": "0adc",
	"./video-ecosystems.png": "28f2",
	"./video-homepage.png": "4d66",
	"./video-howto.png": "c7a7",
	"./video-intelligence.png": "5b4e",
	"./video-intro.png": "e276",
	"./video-search.png": "73c9",
	"./warning-red.svg": "2dd2",
	"./warning.svg": "d1d5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6b6a";